import React from 'react'

export default class ImportSelect extends React.Component{
  constructor(props){
    super(props);
    this.importSelect = React.createRef();
  };

  componentDidMount(){
    this.initSelect2();
  };

  componentDidUpdate(prevProps, prevState){
    if(this.props.error) {
      $(`#select2-${this.props.name}-import-container`).addClass('has-errors');
    } else{
      $(`#select2-${this.props.name}-import-container`).hasClass('has-errors') ? $(`#select2-${this.props.name}-import-container`).removeClass('has-errors') : null;
    };
  }

  render(){
    return(
      [
        <select key={`${this.props.name}-import-select`} defaultValue={this.props.option} name={this.props.name} id={`${this.props.name}-import`} ref={this.importSelect} className="form-control">
          <option value='' disabled>{this.props.placeholder}</option>
        </select>,
      ]
    );
  };

  initSelect2(){
    $(this.importSelect.current).select2({
      data: this.setImportOptions(),
      allowClear: true,
      placeholder: this.props.placeholder ? this.props.placeholder : I18n.t('select_ellipsis'),
    }).on('change.select2', (e) => {
      this.props.onChange(e);
    });
  };

  setImportOptions(){
    return this.props.options.map((option) => {
      if(option.id) {
        return({
          id: option.id,
          text: option.name,
          selected: this.props.option === option.id ? true : false,
        });
      } else {
        return({
          id: option,
          text: option,
          selected: this.props.option === option ? true : false,
        });
      }
    });
  };

};